import { Link } from "react-router-dom";
import "../styles/Header.css";
import React, { useState } from "react"; // Import useState for managing the menu state
import navmenu from "../assets/menu.png";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
function Hero() {
  // Step 1: Create state for controlling menu visibility
  const [menuOpen, setMenuOpen] = useState(false);

  // Step 2: Toggle function to update state and menu visibility
  const menutoggle = () => {
    setMenuOpen(!menuOpen); // This toggles the state between true/false
  };

  return (
    <div className="header">
      <div className="container">
        <div className="navbar">
          <nav>
            <ul id="menuItems" className={menuOpen ? "open" : ""}>
              <li>
                <Link to="/">
                  <HiOutlineArrowNarrowLeft size={20} color="#333" />
                </Link>
              </li>
              <li>
                <Link to="/earlYears">EarlYears</Link>
              </li>
              <li>
                <Link to="/career">Career</Link>
              </li>
              <li>
                <Link to="/trophies">Trophies</Link>
              </li>
              <li>
                <Link to="/awards">Achievements</Link>
              </li>
              <li>
                <Link to="/gallery">Gallery</Link>
              </li>
            </ul>
          </nav>
          {/* The onClick now triggers the menutoggle function */}
          <img
            src={navmenu}
            className="menu-icon"
            onClick={menutoggle} // Corrected to use React's event handling
            alt="Navigation Menu"
          />
        </div>
      </div>
    </div>
  );
}

export default Hero;
